import prismicColors from "@/lib/prismicio/prismic-colors.json";
import { useTextConversionMethod } from "@/lib/prismicio/useTextConversion";
import { CheckboxIndicator, CheckboxRoot, TickYes, cn, useFacetExcessive } from "@jog/react-components";
import { colorLanguageConverter, gtmFacetSearch } from "@jog/shared";
import { useState } from "react";
import { BOX_CLASSNAME } from "../FormField/const";
const Checkbox = ({ pending, attribute, searchValue, facet, onChange, }) => {
    const [checked, setChecked] = useState(attribute.isselected);
    return (<CheckboxRoot className="mr-1.25 h-4.5 w-4.5 shrink-0 border border-grey-default bg-white" disabled={pending} value={`${facet.facetsettings.title}-${attribute.title}`} id={`${facet.facetsettings.title}-${attribute.title}`} checked={checked} onCheckedChange={(value) => {
            if (!attribute.url)
                return;
            setChecked(value === "indeterminate" ? !checked : value);
            if (searchValue)
                gtmFacetSearch(value ? "check" : "uncheck", facet, attribute, searchValue);
            onChange === null || onChange === void 0 ? void 0 : onChange(attribute.url);
        }}>
            <CheckboxIndicator className="flex items-center justify-center text-current">
                <TickYes className="h-3 w-3"/>
            </CheckboxIndicator>
        </CheckboxRoot>);
};
export const FacetSearch = () => {
    const { facet, searchable, searchValue, setSearchValue, attributes } = useFacetExcessive();
    if (!searchable)
        return <></>;
    return (<>
            <div className={cn(BOX_CLASSNAME, "mb-2 w-full bg-white")}>
                <input className="w-full focus:outline-0" type="text" value={searchValue} onChange={(e) => setSearchValue(e.target.value)} placeholder={facet.facetsettings.searchplaceholder}/>
            </div>
            {attributes.length === 0 && (<div className="py-1 text-sm text-gray-main">{facet.facetsettings.searchnoresultstext}</div>)}
        </>);
};
export const CheckboxFacet = ({ pending, onChange }) => {
    const textConvert = useTextConversionMethod();
    const { display, Showmore, facet, attributes, searchValue } = useFacetExcessive();
    if (!facet)
        return;
    return (<div className="mt-2">
            <FacetSearch />
            <ul className="space-y-2 py-1">
                {attributes
            .filter((_, index) => display(index))
            .map((attribute) => (<li key={attribute.url} className="flex items-center">
                            <Checkbox pending={pending} attribute={attribute} searchValue={searchValue} facet={facet} onChange={onChange}/>
                            <label className="flex cursor-pointer items-center" htmlFor={`${facet.facetsettings.title}-${attribute.title}`}>
                                {facet.facetsettings.title === "Kleur" && (<div className="mr-1.25 inline-block h-4.5 w-4.5 cursor-pointer border border-gray-silver" style={{
                    backgroundColor: colorLanguageConverter(attribute.title, prismicColors),
                }}/>)}
                                <span>
                                    {textConvert(attribute.title)}
                                    <span className="pl-1.25 text-gray-main">({attribute.nrofresults})</span>
                                </span>
                            </label>
                        </li>))}
            </ul>
            <Showmore className="mt-1.25 py-1 text-base lg:hover:text-red-mona"/>
        </div>);
};
